import { Dropdown, Tooltip, useDrawer } from '@iveco-ti/iveco-ds'
import { FileEdit, FileSearch, Trash } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { GenericContentModel } from '@/common/models/genericContent'
import { useRemoveGenericContent } from '../hooks/useRemoveGenericContent'
import { useSelectedGenericContentStore } from '../stores/useSelectedGenericContentStore'

type GenericContentActiveActionsProps = {
  genericContent: GenericContentModel
}

export function GenericContentActiveActions({
  genericContent,
}: GenericContentActiveActionsProps) {
  const { t } = useTranslation(['common', 'settings'])
  const { setGenericContent } = useSelectedGenericContentStore()
  const { handleRemoveGenericContent } = useRemoveGenericContent()

  const drawerEditGenericContent = useDrawer('drawer-edit-generic-content')
  const drawerViewGenericContent = useDrawer('drawer-view-generic-content')

  const handleViewGenericContent = () => {
    setGenericContent(genericContent)
    drawerViewGenericContent.open()
  }

  const handleEditGenericContent = () => {
    setGenericContent(genericContent)
    drawerEditGenericContent.open()
  }

  return (
    <div className="flex flex-row gap-2 items-center justify-center">
      <Tooltip text={t('common:components.table_row.view')}>
        <button
          className="p-1 hover:bg-base-100 rounded"
          type="button"
          onClick={handleViewGenericContent}
        >
          <FileSearch size={18} className="text-brand-700" />
        </button>
      </Tooltip>

      <Tooltip text={t('common:components.table_row.edit')}>
        <button
          className="p-1 hover:bg-base-100 rounded"
          type="button"
          onClick={handleEditGenericContent}
        >
          <FileEdit size={18} className="text-brand-700" />
        </button>
      </Tooltip>

      <Dropdown.Root closeMode="inside">
        <Dropdown.Trigger className="text-brand-700" />

        <Dropdown.Body>
          <Dropdown.List>
            <Dropdown.Item
              onClick={() => handleRemoveGenericContent(genericContent.id)}
              className="text-danger-700 text-sm font-normal"
            >
              <Dropdown.Icon icon={<Trash />} />
              {t('common:components.table_row.remove')}
            </Dropdown.Item>
          </Dropdown.List>
        </Dropdown.Body>
      </Dropdown.Root>
    </div>
  )
}
